var map = {
	"./cs.translation.ts": "ooOH",
	"./de.translation.ts": "qyP5",
	"./es.translation.ts": "QIT9",
	"./fr.translation.ts": "MNdf",
	"./it.translation.ts": "AVys",
	"./sv.translation.ts": "o7jl",
	"./zh.translation.ts": "83tN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qNv+";